const replace = (router, name) => {
  // eslint-disable-next-line no-underscore-dangle
  router.push({ name, replace: true, params: { 0: router?.history?._startLocation } })
}

export default (router, error) => {
  const { status } = error && error.response
  if (status === 500) {
    replace(router, 'InternalServerError')
  } else if (status) {
    replace(router, 'NotFound')
  }
}
